export class IntegralMetricModel {
  ag!: string[];
  d!: number;
  hr!: string;
  singleHr!: string;
  rg!: number;
  val!: string;
  ver!: string;
  global?: { hr: string; singleHr: string };
  shape?: { hr: string; singleHr: string };
  /**
   * Contains calculated value for radar,
   * value in range in between 0 and 1
   */
  gmc!: number;
  /**
   * Contains calculated value for radar of shape normalized metric,
   * value in range in between 0 and 1
   */
  smc!: number;
}

export default class IntegralMetric extends IntegralMetricModel {
  constructor({ ag, d, hr, singleHr, rg, val, ver, gmc, smc, global, shape }: IntegralMetricModel) {
    super();

    this.ag = ag;
    this.d = d;
    this.hr = hr;
    this.singleHr = singleHr;
    this.rg = rg;
    this.val = Number(val).toFixed(2);
    this.global = global;
    this.shape = shape;
    this.ver = ver;
    this.gmc = gmc;
    this.smc = smc;
  }
}
